import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function TicketSuccess() {
  const { user } = useAuth();
  const location = useLocation();
  const [ticketNumber, setTicketNumber] = useState(location.state?.ticketNumber || '');
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get('ticket');
    if (q) setTicketNumber(q);
  }, [location.search]);

  useEffect(() => {
    const pieces = Array.from({ length: 28 }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 0.4}s`,
      color: ['#FF6B00', '#FF8C33', '#fbbf24', '#34d399', '#60a5fa'][i % 5],
    }));
    setConfetti(pieces);
  }, []);

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem', position: 'relative', overflow: 'hidden' }}>
      {confetti.map((c) => (
        <span
          key={c.id}
          className="confetti-piece"
          style={{ left: c.left, top: '-12px', background: c.color, animationDelay: c.delay }}
        />
      ))}

      <div className="tr-card" style={{ padding: '2.5rem 2rem', textAlign: 'center', maxWidth: 440, position: 'relative', zIndex: 1 }}>
        <div
          style={{
            width: 88,
            height: 88,
            borderRadius: '50%',
            background: 'var(--primary-soft)',
            color: 'var(--primary)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '2.5rem',
            margin: '0 auto 1.25rem',
            fontWeight: 700,
          }}
        >
          ✓
        </div>
        <h1 style={{ marginTop: 0 }}>Your ticket has been received</h1>
        <p style={{ color: 'var(--text-muted)' }}>Thank you for your feedback. Our team will review it shortly.</p>
        <div
          style={{
            fontSize: '1.5rem',
            fontWeight: 800,
            color: 'var(--primary)',
            margin: '1rem 0',
            letterSpacing: '0.02em',
          }}
        >
          {ticketNumber || '—'}
        </div>
        <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>Typical first response within one business day for non-urgent items. Urgent issues are prioritized immediately.</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', justifyContent: 'center', marginTop: '1.75rem' }}>
          <Link to="/" className="tr-btn tr-btn-outline">
            Back to Home
          </Link>
          <Link to={user?.role === 'visitor' ? '/visitor' : '/'} className="tr-btn tr-btn-primary">
            Raise Another Ticket
          </Link>
        </div>
      </div>
    </div>
  );
}
